import React, { useEffect, useState } from "react";
import arrow from "../../assets/Elipse.png";
import { Button } from "./Button";
import "./homeContent.css";
import { useMediaQuery } from "@mui/material";

interface HeroComponentProps {
  scrollTo: (ref: React.RefObject<HTMLDivElement>) => void;
  goToSelectionRef: React.RefObject<HTMLDivElement>;
  goToPortafolioRef?: React.RefObject<HTMLDivElement>;
}

export const HeroComponent: React.FC<HeroComponentProps> = ({
  scrollTo,
  goToSelectionRef,
  goToPortafolioRef = null,
}) => {
  const isSmallScreen = useMediaQuery("(max-width: 768px)");
  const [shouldShowArrow, setShouldShowArrow] = useState(false);

  const videoSrc = isSmallScreen
    ? "https://ab53efda85cfc.s3.amazonaws.com/grupo-pena-defillo/Digital-Atronauta-compress-low-mobile.mp4"
    : "https://ab53efda85cfc.s3.amazonaws.com/grupo-pena-defillo/Digital-Atronauta-compress-low.mp4";

  useEffect(() => {
    setTimeout(() => {
      setShouldShowArrow(true);
    }, 3000);
  }, []);

  return (
    <>
      <div className="relative h-screen w-screen overflow-hidden">
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src={videoSrc} type="video/mp4" />
          Tu navegador no admite la reproducción de video.
        </video>

        {/* Left-to-right vignette */}
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-black via-black/70 to-transparent" />
        {/* Top fade */}
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-black/60 via-transparent to-transparent" />
        {/* Bottom fade */}
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />

        {/* Content */}
        <div className="absolute z-10 top-1/2 left-10 md:left-10 -translate-y-1/2">
          <div className="title-homeContent text-6xl">
            SOMOS EL PODER <br /> DE LA UNIÓN
          </div>
          <div className="text-white font-normal text-base pb-5 leading-relaxed text-left">
            Somos el grupo número uno de comunicaciones en <br /> República
            Dominicana y el Caribe.
          </div>

          <div className="mt-6 w-full flex justify-start">
            <Button
              customClass="w-48 h-10 bg-white border-0 font-montserrat font-semibold text-xs leading-5 text-gray-800 uppercase tracking-wider transition-colors duration-200 cursor-pointer hover:bg-white/90"
              onClick={() => scrollTo(goToSelectionRef || goToPortafolioRef)}
            >
              Conocer Más
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll arrow */}
      {shouldShowArrow && (
        <img
          draggable={false}
          onClick={() => scrollTo(goToSelectionRef || goToPortafolioRef)}
          className="absolute right-8 md:right-10 bottom-10 w-12 md:w-14 z-20 cursor-pointer animate-bounce transition-opacity duration-500"
          src={arrow}
          width="50%"
          alt="Scroll down arrow indicator"
        />
      )}
    </>
  );
};
